import { useState, useEffect, useRef, useContext } from "react";
import OneArticle from '../ones/OneArticle';
import { AppContext } from "../App";
import { STR_ALL, STR_CHITCHAT, STR_CLICK_HERE_FOR_MORE_CONFESSIONS, STR_CONFESSIONS, STR_FITNESS, STR_HEALTH_TIPS, STR_NO_DATA_FOUND, STR_PHARMACY, STR_SEARCH_HERE, STR_SHORTS, STR_VIDEOS, STR_VIEW_MORE, STR_VIEW_MORE_HEALTH_TIPS } from "../Strings";
import { callApi, getInlineLoader } from "../Helpers";
import { MdChevronRight, MdOutlineLocalPharmacy, MdOutlineOndemandVideo, MdSearch } from "react-icons/md";
import ContentsSlider from "../ones/ContentsSlider";
import OneConfession from "../ones/OneConfession";
import { LuImage } from "react-icons/lu";
import { IoMdFitness } from "react-icons/io";
import { BsChatSquareDotsFill } from "react-icons/bs";
import BannerContainer from "../ones/BannerContainer";

export default function Feed({ }) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  
  const [filter, setFilter] = useState('');
  const [category, setCategory] = useState('');

  async function init() {
    setReady(false);
    await Promise.all(
      [
        appContext.getArticlesFeed(),
				appContext.getConfessionsFeed(),
        appContext.getCurrentUserData(),
      ]
    )
    setReady(true);
  }

  
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    
  }, [filter, category])

  if(ready) {
    return (
      <div
        style={{
          width: "100%",
        }}
      >
        <div className="container">
					<div className="row">

						<div className="col-md-12">
							

							<div className="card bg-background">
								<ContentsSlider type="article" contents={appContext.articlesFeed?.slice(0, 10)}/>

								<div
									style={{
										width: "100%",
										padding: "10px"
									}}
									className="text-center"
								>
									<button
										className="btn btn-outline-secondary btn-rounded bg-background"
										style={{
											padding: "10px",
											marginTop: "20px",
											marginBottom: "20px",
											fontSize: "14px"
										}}
										onClick={() => {
											appContext.navTo({
												item: 'home',
												subItem: 'articles',
											})
										}}
									>
										{STR_VIEW_MORE_HEALTH_TIPS[appContext.language]}
									</button>
								</div>
							</div>
						</div>

						<div  className="col-md-12 mt-2 mb-2">
							
							<div className="row">
								<div 
									className="col-4 text-center" 
									style={{ 
										overflow: "hidden" 
									}}
									onClick={() => {
										appContext.navTo({
											item: 'pharmacy',
										})
									}}
								>
									<div className="mHomePill">
										<MdOutlineLocalPharmacy className="text-primary" size={40}/>
									</div>
									<h6
										className="font-semi-bold text-center"
										style={{
											fontSize: "14px",
											marginTop: "5px"
										}}
									>
										{STR_PHARMACY[appContext.language]}
									</h6>
								</div>
								
								<div 
									className="col-4 text-center" 
									style={{ 
										overflow: "hidden" 
									}}
									onClick={() => {
										appContext.navTo({
											item: 'fitness',
										})
									}}
								>
									<div className="mHomePill">
										<IoMdFitness className="text-primary" size={40}/>
									</div>
									<h6
										className="font-semi-bold text-center"
										style={{
											fontSize: "14px",
											marginTop: "5px"
										}}
									>
										{STR_FITNESS[appContext.language]}
									</h6>
								</div>

								<div 
									className="col-4 text-center" 
									style={{ 
										overflow: "hidden" 
									}}
									onClick={() => {
										appContext.navTo({
											item: 'chitchat',
										})
									}}
								>
									<div className="mHomePill">
										<BsChatSquareDotsFill className="text-primary" size={40}/>
									</div>
									<h6
										className="font-semi-bold text-center"
										style={{
											fontSize: "14px",
											marginTop: "5px"
										}}
									>
										{STR_CHITCHAT[appContext.language]}
									</h6>
								</div>		

							</div>
						</div>

						<div className="col-md-12 mt-2 mb-2">
							<BannerContainer 
								url={appContext.systemParams.banner1Url}
								nav={JSON.parse(appContext.systemParams.banner1Nav || '{}')}
							/>
						</div>

						<div className="col-md-12 mt-4 mb-2">
							<div 
								className="d-flex justify-content-between mt-3 mb-2"
								onClick={() => {
									appContext.navTo({
										item: 'home',
										subItem: 'confessions',
									})
								}}
							>
								<h6
									className="mSectionTitle text-primary mNoMargin align-self-center"
									onClick={() => {
										appContext.navTo({
											item: 'home',
											subItem: 'confessions',
										})
									}}
								>
									{STR_CONFESSIONS[appContext.language]}
								</h6>

								<MdChevronRight
									size={34}
									className="align-self-center mNoMargin"
									style={{
										flexShrink: "0",
									}}
									onClick={() => {
										appContext.navTo({
											item: 'home',
											subItem: 'confessions',
										})
									}}
								/>
							</div>

							<div className="card bg-background">
								{
									(appContext.confessionsFeed && appContext.confessionsFeed.length > 0) ?
									<>
										{
											appContext.confessionsFeed.slice(0, 4).map((item, i) => {
												return (
													<div style={{ width: "100%" }} key={i}>
														<OneConfession data={item}/>
														<hr/>
													</div>
												)
											})
										}

										
										<div
											style={{
												width: "100%",
												padding: "10px"
											}}
											className="text-center"
										>
											<button
												className="btn btn-outline-secondary btn-rounded bg-background"
												style={{
													padding: "10px",
													marginTop: "10px",
													marginBottom: "30px",
													fontSize: "14px"
												}}
												onClick={() => {
													appContext.navTo({
														item: 'home',
														subItem: 'confessions',
													})
												}}
											>
												{STR_CLICK_HERE_FOR_MORE_CONFESSIONS[appContext.language]}
											</button>
										</div>
										
									</>
									:
									<div className="col-md-12">
										<h6
											style={{
												fontSize: "12px"
											}}
										>
											{STR_NO_DATA_FOUND[appContext.language]}
										</h6>
									</div>
								}
							</div>
						</div>

						<div className="col-md-12 mt-2 mb-2">
							<BannerContainer 
								url={appContext.systemParams.banner2Url}
								nav={JSON.parse(appContext.systemParams.banner2Nav || '{}')}
							/>
						</div>

					</div>
				</div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
        className="mNoScrollBar"
      >
        <div className="container mSupportLoading">
          {getInlineLoader()}
        </div>
      </div>
    );
  }
}
